import React, { useContext, useEffect, useState } from 'react';
import DataTable from "react-data-table-component";
import axiosIntance from '../../../config/axios'
import { RootContext } from '../../../App';
import refactorStructureData from '../../../helpers/refactorDataMenu';
import { Card, CardBody, CardHeader } from "@material-tailwind/react";
import { Link } from 'react-router-dom'
import Swal from "sweetalert2";

const AdminRole = () => {

    const [data , setData] = useState([])
    const [pending , setPending] = useState(true)
    const [roleid , setRoleid] = useState()
    const token = localStorage.getItem("access_token")
    const group = JSON.parse(localStorage.getItem("group"))
    const {state , setState} = useContext(RootContext)

    function handleDelete(role) {
        
        axiosIntance.post('delete_admin_role' , {
        token :token ,
        group :group.wbid,
        roleid: role
        }).then((res)=>{

            if(res.data.code === 0) {

                Swal.fire("Success", 'Admin Role Are Deleted', 'success').then(() => {

                    setPending(true)
                    setRoleid(role)
                })
            }else if(res.data.code === 400) {

                Swal.fire("Warning", "Role are used by admin can't deleted", 'warning')
            }else{

                Swal.fire("Error", 'Internal server error', 'error')
            }

            setState({
                ...state,
                group: res.data.data.additional_data.group,
                menu: refactorStructureData(res.data.data.additional_data.menu),
            })
        })
    }

    useEffect(()=>{

        axiosIntance.post('get_admin_role' , {
        token :token ,
        group :group.wbid
        }).then((res)=>{

            setPending(false)
            setData(res.data.data.list)
            setState({
                ...state,
                group: res.data.data.additional_data.group,
                menu: refactorStructureData(res.data.data.additional_data.menu),
            })
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[roleid]);

    const columns = [
        {
        name: "Role",
        selector: (row) => row.access_name,
        sortable: false,
        },
        {
        name: "Description",
        selector: (row) => {
            let desc = row.description ? row.description : ""
            return desc;
        },
        sortable: false,
        },
        {
        name: "Edit Access",
        selector: (row) => {

            return <Link to={"/admin/role/" + row.role_id}>
                <button className='w-14 h-7 bg-green-500 rounded-md text-white'>Edit</button>
            </Link>
        },
        sortable: false,
        },
        {
        name: "Delete Role",
        selector: (row) => {

            return <button className='w-14 h-7 bg-red-500 rounded-md text-white' onClick={() => {

                handleDelete(row.role_id)
            }}>Delete</button>
        },
        sortable: false,
        },
        
    ]

  return (
    <Card>
        <CardHeader color="blueGray" contentPosition="left">
            <h2 className="text-white text-2xl">Admin Role</h2>
        </CardHeader>
            <Link to={"/admin/new/role"}>
                <button className='h-[55px] bg-[#04A9F4] p-4 rounded-lg ml-4 text-white'>
                    Create New Role
                </button>
            </Link>
        <CardBody >
            <div className='w-full h-auto border-2 border-gray-800 border-solid rounded-md flex flex-col'>
                <div className='w-full h-20 bg-gray-600 px-10 flex items-center'>
                    <div className='text-[24px] text-white'>
                        Role List
                    </div>
                </div>
                <DataTable
                    columns={columns}
                    data={data}
                    progressPending={pending}
                />
            </div>
        </CardBody>
    </Card>
  )
}

export default AdminRole